import { Button } from '@/shared/ui'
import { OnboardingChecklist } from '@/widgets/onboarding-checklist'
import { OnboardingPreview } from '@/widgets/onboarding-preview'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'

const titleDesktopTypography = designTokens.typography.onboarding.titleDesktop
const subtitleTypography = designTokens.typography.body.base

const titleDesktopStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.strong,
  ...typographyStyle(titleDesktopTypography),
}

const subtitleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.strong,
  ...typographyStyle(subtitleTypography),
}

type OnboardingOldPageDesktopProps = {
  onDashboardRedirect: () => void
  onTelegramBot: () => void
}

export function OnboardingOldPageDesktop({
  onDashboardRedirect,
  onTelegramBot,
}: OnboardingOldPageDesktopProps) {
  return (
    <div
      className="hidden w-full flex-col items-center lg:flex"
      style={{
        gap: designTokens.spacing.xxxl,
      }}
    >
      <div
        className="flex w-full flex-col items-center text-center"
        style={{
          gap: designTokens.spacing.xs,
          marginTop: designTokens.components.choosePlan.desktop.headerGap,
          maxWidth: designTokens.components.onboarding.desktop.textWidth,
        }}
      >
        <h1 style={titleDesktopStyle}>Добро пожаловать!</h1>
        <div style={subtitleStyle}>
          <p style={{ margin: 0 }}>ДД.ММ.ГГГГ подписка будет продлена за Х ₽</p>
          <p style={{ margin: 0 }}>
            Мы напомним о списании за N дней, отправив письмо на ваш email.
          </p>
        </div>
      </div>
      <div
        className="flex w-full flex-col items-center"
        style={{
          gap: designTokens.spacing.checkoutActionsGap,
          maxWidth: designTokens.components.onboarding.desktop.contentWidth,
        }}
      >
        <div
          className="flex w-full justify-center"
          style={{
            gap: designTokens.spacing.jumbo,
          }}
        >
          <OnboardingPreview
            style={{ width: designTokens.components.onboarding.desktop.panelWidth }}
          />
          <OnboardingChecklist
            style={{ width: designTokens.components.onboarding.desktop.panelWidth }}
          />
        </div>
        <div
          className="flex w-full justify-center"
          style={{
            gap: designTokens.spacing.jumbo,
          }}
        >
          <Button
            variant="tertiaryMovement"
            onClick={onDashboardRedirect}
            style={{ width: designTokens.components.onboarding.desktop.buttonsWidth }}
          >
            Перейти в личный кабинет
          </Button>
          <Button
            variant="secondarySubmit"
            onClick={onTelegramBot}
            style={{ width: designTokens.components.onboarding.desktop.buttonsWidth }}
          >
            Перейти в телеграм-бот для активации
          </Button>
        </div>
      </div>
    </div>
  )
}
